<template lang="pug">
div
  v-container.pa-0(@click="clickItem(checkboxActive,income)")
    v-row.align-center.ma-0.px-4.py-1(
      style="background-color: var(--v-basic600T08)",
      v-if="isFirstDate"
    )
      v-col.ma-0.pa-0
        .s2.primary400--text {{ getMonth(income.record_date) }}
    v-row.align-center.ma-0.px-4.py-3.border-bottom
      v-col.shrink(v-if="checkboxActive")
        y-checkbox.mb-n2(:disabled ="checkboxDisabled"  v-model="clicked"  style="height:30px" readonly="readonly" )
      v-col.ma-0.pa-0(:cols="checkboxActive ? '7' : '8'" :md="checkboxActive ? '8' : '9'")
        .s1.basic800--text {{ income.name }}
        .c1.basic600--text.d-inline-flex
          | {{ '#' + income.rid }}
          span.mx-1(style="font-size: 3px !important") ●
          | {{ getShortDate(income.record_date) }}
          span.mx-1(style="font-size: 3px !important") ●
          .text-capitalize {{ income.category == null ? 'Others' : income.category.name }}
      v-col.ma-0.pa-0.text-end(:cols="checkboxActive ? '3' : '4'" :md="checkboxActive ? '2' : '3'")
        .s1(
          :class="getStatus() == 'overdue' ? 'danger500--text' : ''"
        ) {{ income.amount | displayPrice }}
        .c1.danger500--text.text-capitalize(
          v-if="getStatus() == 'overdue'"
        ) {{ getStatus() }}
        .c1.success500--text.text-capitalize(
          v-if="getStatus() == 'settled'"
        ) {{ getStatus() }}
        .c1.primary400--text.text-capitalize(
          v-if="getStatus() == 'unsent' || getStatus() == 'quotation'"
        ) {{ getStatus() }}
  .actionSheet
    y-bottom-sheet(v-model="actionSheet", inset, scrollable, max-width="600px")
      v-card(flat)
        v-card-title.py-3.px-4(
          :style="'background-color:var(--v-' + getColor(getStatus(), 'T') + ')'"
        )
          v-row.pl-3
            v-col.pa-0
              .s1.primary500--text(v-if="getStatus() == 'quotation'") Quotation
              .s1.primary500--text(v-else) {{ invoiceName }} {{ '#' + income.rid }}
              .c1.text-capitalize(
                v-if="getStatus() != 'quotation'"
                :class="getColor(getStatus(), 'S') + '--text'"
              ) {{ getStatus() }}
            v-col.shrink.pa-0
              v-btn(
                outlined,
                color="primary500",
                x-small,
                height="24",
                width="53",
                @click="viewInvoice()",
                style="background-color: var(--v-basic600T08)"
              )
                .button-AA-tiny.primary500--text View
            v-col.shrink.pa-0
              v-menu(left, offset-y)
                template(v-slot:activator="{ on }")
                  v-btn.mr-1(
                    text,
                    icon,
                    min-width="auto",
                    :ripple="false",
                    v-on="on"
                  )
                    eva-icon(
                      name="more-vertical",
                      :fill="$vuetify.theme.themes[$theme].primary500",
                      height="25",
                      width="25"
                    )
                v-list(dense)
                  v-list-item(v-if="payments.length > 0 && income.payment_status !== 'paid'" @click="openPaymentListDialog = true")
                    v-list-item-content
                      v-list-item-title.s2.basic800--text Edit payment history
                  v-list-item(v-if="income.amount_remaining > 0 && income.payment_status !== 'paid'" @click="showAddIncomeDialog = true")
                    v-list-item-content
                      v-list-item-title.s2.basic800--text Edit {{ invoiceName }}
                  v-list-item(@click="clickDelete()")
                    v-list-item-content
                      v-list-item-title.s2.basic800--text Delete
        v-card-text.px-4.pb-3
          v-row.border-bottom.py-1
            v-col
              .p2.primary400--text {{ income.description || (income.products.length > 0 ? income.products[0].name : '')}}
              .p2.primary400--text.text-capitalize {{ income.category == null ? 'Others' : income.category.name }}
            v-col.text-end(cols="4")
              .p2.primary400--text {{ income.record_date | displayDate }}
              .p2.primary400--text {{ income.name }}
          v-row.border-bottom.py-1(v-if="getStatus() != 'quotation' && income.due_date" )
            v-col
              .p2(
                :class="getStatus() == 'overdue' ? 'danger500--text' : 'primary400--text'"
              ) Due: {{ income.due_date | displayDate }}
            v-col.shrink.px-2(
              v-if="getStatus() != 'settled' && getStatus() != 'quotation'"
            )
              v-btn.elevation-0.pa-0(
                v-if="getStatus() == 'overdue'"
                text,
                color="transparent",
                x-small,
                light,
                @click="showSendReminderDialog = true",
              )
                eva-icon(
                  name="calendar-outline",
                  :fill="$vuetify.theme.themes[$theme].info500",
                  height="15"
                )
                .button-Aa-small.info500--text.text-capitalize reminder
              v-btn.elevation-0.pa-0(
                v-else
                text,
                color="transparent",
                x-small,
                light,
                @click="showScheduleReminderDialog = true",
              )
                eva-icon(
                  name="calendar-outline",
                  :fill="$vuetify.theme.themes[$theme].info500",
                  height="15"
                )
                .button-Aa-small.info500--text.text-capitalize schedule reminder
          div.border-bottom.py-1(v-if="payments.length > 0")
            .p2.primary400--text.py-1.mt-1 Payment history
            .showMoreList
              v-row.pt-1(v-for="(payment, index) in listToShow" v-if="index < payments.length" :key="index" no-gutters)
                v-col
                  .p2.primary500--text.d-inline-flex
                    | {{ payments[index].date | displayDate }}
                    span.mx-1(style="font-size: 3px !important") ●
                    | {{ payments[index].payment_method }}
                v-col.text-end
                  .c1.basic600--text.d-inline-flex
                    | {{ payments[index].amount | displayPrice }}
              div.text-center(v-if="listToShow < payments.length || payments.length > listToShow")
                  v-btn.ma-2(@click="listToShow+=3" text,
                  color="transparent",
                  :ripple="false",
                  x-small,
                  light,)
                    .button-Aa-small.info500--text.text-capitalize Show More
              div.text-center(v-if="payments.length > 3 && listToShow >= payments.length && payments.length > 1")
                  v-btn.ma-2(@click="listToShow=3" text,
                  color="transparent",
                  :ripple="false",
                  x-small,
                  light,)
                    .button-Aa-small.info500--text.text-capitalize Show Less
          v-row.py-1
            v-col
              .s2.primary500--text(:class="(getStatus() == 'overdue' && income.amount_remaining == income.amount)? 'danger500--text' : ''") Total {{ income.amount_remaining ? 'amount due' : ''}}
              .p2(v-if="income.amount_remaining > 0 && income.amount_remaining != income.amount" :class="getStatus() == 'overdue'? 'danger500--text' : 'basic600--text'") Balance due
            v-col.text-end
              .s2.primary500--text(:class="(getStatus() == 'overdue' && income.amount_remaining == income.amount)? 'danger500--text' : ''") {{ income.amount | displayPrice }}
              .p2(v-if="income.amount_remaining > 0 && income.amount_remaining != income.amount" :class="getStatus() == 'overdue'? 'danger500--text' : 'basic600--text'") {{ income.amount_remaining | displayPrice  }}
          v-row.py-1(no-gutters v-if="getStatus() != 'settled'")
            v-col.pr-1(cols="6")
              v-btn.px-1(
                outlined,
                color="info500",
                height="40",
                @click="clickRecordPayment",
                style="background-color: var(--v-infoT08)"
                block
              )
                .button-AA-small.info500--text {{ income.quotation ? 'update quotation' : 'record payment' }}
            v-col.pl-1(cols="6")
              v-btn.px-1(
                depressed,
                color="info500",
                height="40",
                @click="shareSheet = true",
                style="background-color: var(--v-infoT08)"
                block
              )
                .button-AA-small.basic100--text share {{ invoiceName }}
          v-row.pt-1.pa-0(v-else)
            v-col.py-1
              v-btn(
                outlined,
                color="info500",
                height="40",
                @click="shareSheet = true",
                style="background-color: var(--v-infoT08)"
                block
              )
                .button-AA-small.info500--text share {{ invoiceName }}

  .modals
    add-income(v-if="showAddIncomeDialog" :open.sync="showAddIncomeDialog" :parentIncome.sync="income")
    income-invoice(v-if="openInvoiceDialog" :open.sync="openInvoiceDialog" :parentIncome.sync="income")
    RecordPayment(v-if="showRecordPaymentDialog" :open.sync="showRecordPaymentDialog" @payment-added="handlePaymentAdded" :parentIncome.sync="income")
    PaymentList(v-if="openPaymentListDialog" :open.sync="openPaymentListDialog" :payments.sync="payments" :parentIncome.sync="income" @edited="handleEditItem")
    send-reminder(v-if="showSendReminderDialog" :open.sync="showSendReminderDialog" :selectedInvoices="selectedInvoices")
    schedule-reminder(v-if="showScheduleReminderDialog" :open.sync="showScheduleReminderDialog" type="income" :selectedInvoices="selectedInvoices")
    y-dialog(v-model="openDeleteDialog", max-width="290", persistent)
      v-card
        v-card-title.h6.basic800--text.px-4 Delete income
        v-card-text.p2.primary500--text.px-4
          | Are you sure you want to delete this item? This item will be deleted permanently.
        v-card-actions
          v-spacer
          v-btn(color="white", text, @click="openDeleteDialog = false")
            .button-Aa-small.primary400--text Cancel
          v-btn(
            color="danger500",
            depressed,
            dark,
            @click="startDelete",
            :loading="isLoading"
          )
            .button-AA-small.basic100--text Delete
    y-bottom-sheet(v-model='shareSheet' inset max-width="600px")
      v-list
        div.pt-2.px-6.s2.primary400--text Share url by
        v-list-item(@click="clickSendInvoice()")
          v-list-item-avatar.my-0
            v-icon(color="#455A64" size="24") fab fa-whatsapp
          v-list-item-title.s2.basic1000--text WhatsApp
        v-list-item(v-clipboard:copy="getShareLinkURL()" v-clipboard:success="copyUrl")
          v-list-item-avatar.my-0
            v-icon(size="24") mdi-content-copy
          v-list-item-title.s2.basic1000--text Copy Link
            div.c1.primary400--text {{getShareLinkURL()}}

</template>
<script>
import { mapGetters, mapActions } from "vuex"
import { DateTime } from 'luxon'
import AddIncome from '@/components/yezzabook/dialogs/income/addincome/AddIncome.vue'
import IncomeInvoice from '@/components/yezzabook/dialogs/income/IncomeInvoice.vue'
import RecordPayment from '@/components/yezzabook/dialogs/income/RecordPayment.vue'
import SendReminder from '@/components/yezzabook/dialogs/SendReminder.vue'
import ScheduleReminder from '@/components/yezzabook/dialogs/ScheduleReminder.vue'
import PaymentList from '@/components/yezzabook/dialogs/income/PaymentList.vue'

export default {
  name: "IncomeItem",
  props: ["parentIncome", "isFirstDate","checkboxActive", "clickedItem","bulkActionType"],
  components: { AddIncome, IncomeInvoice, RecordPayment, PaymentList, SendReminder, ScheduleReminder },
  data: () => ({
    shareSheet: false,
    actionSheet: false,
    openPaymentListDialog: false,
    showAddIncomeDialog: false,
    clicked: false,
    isLoading: false,
    listToShow: 3,
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    openDeleteDialog: false,
    openInvoiceDialog: false,
    selectedInvoices: [],
    showRecordPaymentDialog: false,
    payments: [],
    showScheduleReminderDialog: false,
    showSendReminderDialog: false,
  }),
  mounted(){
    this.clicked = this.clickedItem
    this.selectedInvoices.push(this.parentIncome)
  },
  computed: {
    ...mapGetters({
      company: "getCompany",
    }),
    income: {
      get() {
        return this.parentIncome
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    invoiceName () {
      if (this.income.payment_status === 'paid') {
        return 'Receipt'
      }
      return this.income.quotation ? 'Quotation' : 'Invoice'
    },
    checkboxDisabled () {
      return ['send_reminder', 'scheduled_reminder'].includes(this.bulkActionType) && (this.getStatus() == 'settled' || this.getStatus() == 'quotation')
    }
  },
  watch: {
    bulkActionType () {
      this.clicked = false
    }
  },
  methods: {
    ...mapActions(["showMessage"]),
    clickItem(checkbox,invoice){
      if (!checkbox) {
          if (this.payments.length === 0 && this.income.amount_remaining != this.income.amount) {
          this.fetchPayments()
        }
        this.actionSheet = true
      } else {
        if (['send_reminder', 'scheduled_reminder'].includes(this.bulkActionType) && (this.getStatus() == 'settled' || this.getStatus() == 'quotation')) {
          this.showMessage(['error', this.$t('error_message.select_only_overdue')])
        } else {
          this.$emit('selectInvoice', invoice)
          this.clicked = !this.clicked
        }
      }
    },
    fetchPayments () {
      this.$axios.get(`/books/${this.company.slug}/incomes/${this.income.pid}/payments?ordering=-id`)
        .then((response) => {
          this.payments = response.data.results
        })
        .catch(() => {})
    },
    getMonth(val) {
      const date = DateTime.fromISO(val)
      return date.monthLong + " " + date.year
    },
    getShortDate(val) {
      const date = DateTime.fromISO(val)
      return date.day + " " + date.monthShort
    },
    getColor(val, type) {
      var color;
      if (val == "overdue" && type == "T") {
        color = "dangerT08";
      } else if (val == "settled" && type == "T") {
        color = "successT08";
      } else if ((val == "sent" || val == "unsent" || val == "quotation") && type == "T") {
        color = "basic600T08";
      } else if ((val == "sent" || val == "unsent" || val == "quotation") && type == "S") {
        color = "primary400";
      } else if (val == "settled" && type == "S") {
        color = "success500";
      } else if (val == "overdue" && type == "S") {
        color = "danger500";
      }
      return color;
    },
    getStatus() {
      const stat = this.income.payment_status
      const dueString = this.income.due_date ? this.income.due_date : ''
      const quotation = this.income.quotation
      const sent = this.income.reminder_sent
      if (stat == 'paid') {
        return "settled";
      } else if (quotation){
        return "quotation";
      } else if (sent){
        return "sent";
      } else {
        if (dueString) {
          const currentDate = DateTime.local()
          const duedate = DateTime.fromFormat(dueString, 'yyyy-MM-dd')
          if (this.income.amount_remaining > 0 && currentDate.startOf("day") > duedate.startOf("day")) {
            return "overdue";
          } else {
            return "unsent";
          }
        } else {
          return "unsent";
        }
      }
    },
    viewInvoice () {
      this.openInvoiceDialog = true
    },
    copyUrl () {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
      this.shareSheet = false
    },
    clickDelete() {
      this.openDeleteDialog = true;
    },
    startDelete() {
      this.isLoading = true
      this.axios.patch(`/leads/${this.income.pid}/`, { status: 'deleted' })
        .then(() => {
          this.$emit('deleted', this.income)
          this.openDeleteDialog = false
          this.actionSheet = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handlePaymentAdded (item) {
      this.payments.splice(0, 0, item)
    },
    handleEditItem (item) {
      let editIndex = 0
      this.payments.forEach((payment, index) => {
        if (payment.uid === item.uid) {
          editIndex = index
        }
      })
      this.payments = this.payments.filter((x) => x.uid !== item.uid)
      this.payments.splice(editIndex, 0, item)
    },
    getShareLinkURL () {
      let path = 'invoices'
      if (this.income.payment_status === 'paid') {
        path = 'receipts'
      }
      if (this.income.quotation) {
        path = 'quotations'
      }
      return `${this.$subdomain}.${process.env.VUE_APP_BASE_DOMAIN}/${path}/${this.income.pid}`
    },
    clickRecordPayment () {
      this.showRecordPaymentDialog = true
    },
    clickSendInvoice () {
      let url = `https://api.whatsapp.com/send?text=${this.getShareLinkURL()}`
      if (this.income.phone) {
        url = `https://api.whatsapp.com/send?phone=${this.$options.filters.phoneSanitized(this.income.phone)}&text=${this.getShareLinkURL()}`
      }
      window.open (url)
    },
  },
};
</script>
<style scoped>
.border-bottom {
  border-bottom: 1px solid var(--v-basic300);
  border-radius: 0 !important;
}
</style>